// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"752":"1acbecda","3780":"ff60fd68","4768":"f10762c2"}[chunkId] + ".chunk.css";
};